"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expand = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Expand = function Expand() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M5.627 12.627l6.853 6.84a.667.667 0 00.947 0l.946-.947a.654.654 0 000-.933L9.773 13h13.56a.667.667 0 00.667-.667V11a.666.666 0 00-.667-.667H9.773l4.6-4.586a.667.667 0 000-.947l-.946-.933a.667.667 0 00-.947 0l-6.853 6.84a1 1 0 00-.294.706v.507c.003.264.108.518.294.707z"
  }), react_1.default.createElement("rect", {
    width: "2.667",
    height: "21.333",
    y: "1",
    fill: "currentColor",
    rx: "0.5"
  }));
};

exports.Expand = Expand;